import { useMutation, useQueryClient } from '@tanstack/react-query';
import { type MutationOptions, gqlFetcher } from '../fetcher';
import { DeleteParticipantFileLabel } from '../mutations/deleteParticipantFileLabel.mutation';
import type {
  DeleteParticipantFileLabelMutation,
  DeleteParticipantFileLabelMutationVariables,
} from '../types';

export const useDeleteParticipantFileLabelMutation = (
  options?: MutationOptions<
    DeleteParticipantFileLabelMutation,
    DeleteParticipantFileLabelMutationVariables
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(DeleteParticipantFileLabel), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('participant'),
      });
    },
  });
};
